var React = require('react');

function Devto (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"21.25","y":"21.25","width":"57.5","height":"57.5","rx":"2.75","stroke":"#030E27","strokeWidth":"2.5","key":0}),React.createElement("path",{"d":"M30 58.5V40.5C30 40.5 37 40.5 37.5 41.5C38 42.5 38 57.5 37.5 58C37 58.5 30 58.5 30 58.5Z","stroke":"#030E27","strokeWidth":"2.5","key":1}),React.createElement("path",{"d":"M54 40.7222C54 40.7222 46 40.2222 45.5 40.7222C45 41.2222 45 49.9722 45 49.9722M54 59.2222C54 59.2222 46 59.7222 45.5 59.2222C45 58.7222 45 49.9722 45 49.9722M45 49.9722H51","stroke":"#030E27","strokeWidth":"2.5","key":2}),React.createElement("path",{"d":"M59 40C59 40 63.5 58.5 64.5 58.5C65.5 58.5 70.5 40 70.5 40","stroke":"#030E27","strokeWidth":"2.5","key":3})]);
}

Devto.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"};

module.exports = Devto;

Devto.default = Devto;
